module.exports = __webpack_public_path__ + "static/media/Layout18.e861c601.png";